const BOTTOM_PANEL = 'bottom-panel';
const SIDEBAR = 'sidebar';

export const BOTTOM_PANEL_CLOSE_BUTTON = `${BOTTOM_PANEL}:button-close`;
export const SIDEBAR_CLOSE_BUTTON = `${SIDEBAR}:button-close`;
export const SIDEBAR_TOGGLE_BUTTON = `${SIDEBAR}:button-toggle`;
